const { Slot } = require("expo-router")

const Layout = () =>{
    return <Slot />
}

export default Layout;